<app-navbar [title]="'Definicje'"></app-navbar>

<div class="container">
	<nav class="nav flex-column">
		<a class="nav-link" routerLink="/definitions/tags-leads">Leady > Tagi</a>
	</nav>
</div>
